import {
  oneOf
} from 'prop-types';

import { TRANSACTION_STATES } from '../../constants';

export default oneOf(Object.values(TRANSACTION_STATES));



// WEBPACK FOOTER //
// ./src/utils/shapes/TransactionState.js